import {VideoEventInterface} from 'app/components/tv/events/VideoEvent';
import {EventHandlerInterface} from 'app/components/tv/handler/EventHandlerInterface';
import VideoAdsInitializedEvent from 'app/components/tv/events/VideoAdsInitializedEvent';
import PlayContentHandler from 'app/components/tv/handler/PlayContentHandler';
import ChangedContentEvent from 'app/components/tv/events/ChangedContentEvent';
import AdFinishedEvent from 'app/components/tv/events/AdFinishedEvent';
import VideoJsPlayerFactory from 'app/components/tv/VideoJsPlayerFactory';
import VideoAdController from 'app/components/tv/VideoAdController';

export default class VideoEventProvider {
  private listeners: Map<string, (() => EventHandlerInterface)[]> = new Map();
  private static instance: VideoEventProvider;
  private handlerMapping = [
    {event: new VideoAdsInitializedEvent(), handler: this.createPlayContentHandler},
    {event: new ChangedContentEvent(), handler: this.createPlayContentHandler},
    {event: new AdFinishedEvent(), handler: this.createPlayContentHandler},
  ];

  private constructor() {}

  static getInstance(): VideoEventProvider {
    if (!VideoEventProvider.instance) {
      VideoEventProvider.instance = new VideoEventProvider();
    }
    return VideoEventProvider.instance;
  }

  up(): void {
    this.handlerMapping.map(({event, handler}) => this.addListener(event, handler));
  }

  private createPlayContentHandler() {
    return new PlayContentHandler(VideoJsPlayerFactory.getInstance, VideoAdController.getInstance);
  }

  down(): void {
    this.handlerMapping.map(({event, handler}) => this.removeListener(event, handler));
  }

  dispatch(event: VideoEventInterface): void {
    const handlers = this.getListeners(event);
    if (!handlers) {
      return;
    }
    handlers.forEach(handler => handler().handle(event));
  }

  private getListeners(event: VideoEventInterface): (() => EventHandlerInterface)[] {
    return this.listeners.get(event.getName()) || [];
  }

  private addListener(event: VideoEventInterface, handler: () => EventHandlerInterface): void {
    const currentEventListeners = this.getListeners(event);
    if (!currentEventListeners.length) {
      this.listeners.set(event.getName(), [handler]);
      return;
    }
    currentEventListeners.push(handler);
  }

  private removeListener(event: VideoEventInterface, handler: () => EventHandlerInterface): void {
    const listenersByEvent = this.getListeners(event);
    if (!listenersByEvent.length) {
      return;
    }
    // find and remove handler
    const index = listenersByEvent.findIndex(h => h.constructor.name === handler.constructor.name);
    if (index >= 0) {
      listenersByEvent.splice(index, 1);
    }
    // remove event from map if no more handlers
    if (listenersByEvent.length === 0) {
      this.listeners.delete(event.getName());
    }
  }
}
